import { useState } from "react";
import { useTranslation } from "react-i18next";
import PageShell, { Breadcrumb } from "@/components/feature/PageShell";

const newsArticles = [
  {
    date: "2025年12月15日",
    categoryKey: "brand",
    title: "第二屆世界品牌大會籌備工作全面啟動，全球品牌領袖齊聚香港",
    excerpt: "國際品牌科學院正式宣布，第二屆世界品牌大會暨世界品牌日活動將於2026年5月10日在香港會議展覽中心隆重舉行。目前各項籌備工作已全面啟動。",
    image: "https://readdy.ai/api/search-image?query=Luxurious%20conference%20ballroom%20with%20cascading%20crystal%20chandeliers%20and%20floor%20to%20ceiling%20burgundy%20velvet%20drapes%2C%20warm%20golden%20lighting%20casting%20soft%20shadows%20across%20polished%20marble%20floors%2C%20refined%20editorial%20atmospherics%2C%20cream%20and%20deep%20crimson%20palette%2C%20elegant%20minimalist%20stage%20design%20with%20subtle%20floral%20arrangements%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=news-article-01&orientation=landscape&nocache=true",
  },
  {
    date: "2025年11月28日",
    categoryKey: "academic",
    title: "國際品牌科學院與華僑大學簽署戰略合作協議，共建品牌研究高地",
    excerpt: "國際品牌科學院與華僑大學正式簽署戰略合作框架協議，雙方將在品牌科學研究、人才培養和國際交流等方面開展全方位合作。",
    image: "https://readdy.ai/api/search-image?query=Refined%20signing%20ceremony%20setting%20with%20dark%20mahogany%20table%20and%20cream%20leather%20folio%2C%20fountain%20pen%20with%20gold%20accents%20beside%20fresh%20calligraphy%20ink%2C%20warm%20amber%20ambient%20lighting%20creating%20soft%20vignette%2C%20burgundy%20and%20ivory%20floral%20centerpiece%2C%20editorial%20still%20life%20photography%20with%20sophisticated%20depth%20of%20field%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=news-article-02&orientation=landscape&nocache=true",
  },
  {
    date: "2025年10月20日",
    categoryKey: "report",
    title: "《中國品牌國際化標桿100強》首次發布，引發業界廣泛關注",
    excerpt: "國際品牌科學院聯合華僑大學國際品牌研究院首次發布《2025中國品牌國際化標桿100強榜單》，全面評估中國品牌國際化進程與競爭力表現。",
    image: "https://readdy.ai/api/search-image?query=Elegant%20hardcover%20report%20displayed%20on%20cream%20marble%20surface%20with%20soft%20warm%20directional%20light%20casting%20gentle%20gradient%20shadow%2C%20burgundy%20silk%20ribbon%20bookmark%20trailing%20gracefully%2C%20gold%20embossed%20cover%20detail%20catching%20subtle%20highlights%2C%20refined%20editorial%20product%20photography%2C%20cream%20and%20deep%20crimson%20palette%20with%20sophisticated%20atmosphere%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=news-article-03&orientation=landscape&nocache=true",
  },
  {
    date: "2025年9月15日",
    categoryKey: "org",
    title: "國際品牌科學院香港總部正式揭牌，開啟品牌科學研究新篇章",
    excerpt: "國際品牌科學院在香港尖沙咀海港城舉行總部揭牌儀式，標誌著這一國際性品牌學術機構正式投入運營。來自全球多個國家和地區的嘉賓出席儀式。",
    image: "https://readdy.ai/api/search-image?query=Refined%20Hong%20Kong%20harbor%20view%20through%20floor%20to%20ceiling%20windows%20during%20golden%20hour%2C%20warm%20amber%20light%20flooding%20a%20sophisticated%20office%20space%20with%20cream%20marble%20desk%20and%20fresh%20orchid%20arrangement%2C%20burgundy%20leather%20executive%20chair%20detail%2C%20elegant%20corporate%20interior%20editorial%20photography%2C%20luxury%20atmosphere%20with%20soft%20atmospheric%20haze%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=news-article-04&orientation=landscape&nocache=true",
  },
  {
    date: "2025年8月10日",
    categoryKey: "international",
    title: "國際品牌科學院與歐洲品牌學會建立戰略合作關係",
    excerpt: "國際品牌科學院與歐洲品牌學會（European Brand Institute）簽署合作備忘錄，雙方將在品牌評估標準互認、聯合研究和學術交流等方面展開深度合作。",
    image: "https://readdy.ai/api/search-image?query=Refined%20diplomatic%20roundtable%20with%20cream%20linen%20tablecloth%20and%20subtle%20gold-rimmed%20porcelain%20coffee%20cups%2C%20warm%20diffused%20window%20light%20creating%20soft%20chiaroscuro%20across%20dark%20wood%20paneling%2C%20elegant%20European%20classic%20interior%20with%20subtle%20architectural%20moldings%2C%20burgundy%20and%20gold%20accent%20details%2C%20sophisticated%20editorial%20still%20life%20with%20timeless%20atmosphere%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=news-article-05&orientation=landscape&nocache=true",
  },
  {
    date: "2025年7月5日",
    categoryKey: "academic",
    title: "首屆品牌科學前沿國際研討會成功舉辦，200餘位專家學者參加",
    excerpt: "由國際品牌科學院主辦的首屆「品牌科學前沿國際研討會」在香港成功舉辦，來自20多個國家和地區的200多位品牌研究專家學者參加了此次學術盛會。",
    image: "https://readdy.ai/api/search-image?query=Elegant%20tiered%20lecture%20hall%20with%20warm%20walnut%20wood%20paneling%20and%20cream%20leather%20seating%2C%20soft%20golden%20theatrical%20lighting%20washing%20across%20the%20stage%2C%20refined%20academic%20atmosphere%20with%20subtle%20burgundy%20curtain%20details%2C%20sophisticated%20university%20interior%20photography%2C%20dramatic%20yet%20warm%20ambient%20chiaroscuro%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=news-article-06&orientation=landscape&nocache=true",
  },
];

const categoryKeys = ["all", "brand", "academic", "report", "org", "international"] as const;

export default function NewsArticles() {
  const { t } = useTranslation();
  const [activeCategory, setActiveCategory] = useState<string>("all");
  const filtered = activeCategory === "all" ? newsArticles : newsArticles.filter(a => a.categoryKey === activeCategory);

  return (
    <PageShell>
      <section className="relative pt-24 pb-20 bg-gradient-to-b from-primary-900 to-primary-800 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://readdy.ai/api/search-image?query=Abstract%20newspaper%20and%20media%20pattern%20with%20flowing%20text%20lines%20and%20geometric%20grids%2C%20deep%20burgundy%20background%2C%20modern%20newsroom%20aesthetic%2C%20warm%20subtle%20lighting%2C%20no%20text%2C%20no%20people&width=1600&height=600&seq=news-articles-hero-01&orientation=landscape')] bg-cover bg-center opacity-18"></div>
        <div className="relative w-full max-w-7xl mx-auto px-4 md:px-8">
          <Breadcrumb items={[{ label: t("nav.news") }, { label: t("news.articles.title") }]} />
          <div className="mt-6 max-w-3xl">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 leading-tight">
              {t("news.articles.title")}
            </h1>
            <p className="mt-4 text-lg text-background-100/80 leading-relaxed">
              {t("news.articles.subtitle")}
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
          {/* Category Filter */}
          <div className="flex flex-wrap gap-2 mb-10">
            {categoryKeys.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-2 text-sm font-medium rounded-full cursor-pointer whitespace-nowrap transition-colors ${
                  activeCategory === cat
                    ? "bg-primary-600 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200"
                }`}
              >
                {cat === "all" ? t("news.articles.all") : t(`news.articles.category.${cat}`)}
              </button>
            ))}
          </div>

          {/* News Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filtered.map((article, i) => (
              <article key={i} className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer">
                <div className="w-full h-48 overflow-hidden">
                  <img src={article.image} alt={article.title} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs font-medium bg-primary-100 text-primary-700 px-2 py-0.5 rounded whitespace-nowrap">{t(`news.articles.category.${article.categoryKey}`)}</span>
                    <span className="text-xs text-foreground-400">{article.date}</span>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-600 transition-colors">{article.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{article.excerpt}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}